// ── Compound component (new) ──────────────────────────────────────────
import { AgentActivityLog } from "./agent-activity-log";
import { AIChatFeedbackDialog } from "./ai-chat-feedback-dialog";
import { AIChatFooter } from "./ai-chat-footer";
import { AIChatMessages } from "./ai-chat-messages";
import { AIChatProvider } from "./ai-chat-provider";
import { AIChatStreamingIndicator } from "./ai-chat-streaming-indicator";
import { AIChatSuggestedPrompts } from "./ai-chat-suggested-prompts";
import { AIChatSuggestionsV2 } from "./ai-chat-suggestions-v2";
import { AIChatSummaryDialog } from "./ai-chat-summary-dialog";
import {
  AIChatInput,
  AIChatInputCancelButton,
  AIChatInputDropZone,
  AIChatInputFilePills,
  AIChatInputFileUpload,
  AIChatInputSendButton,
  AIChatInputTextArea,
} from "./input";
import {
  AIChatMessage,
  AIChatMessageAnalytics,
  AIChatMessageAvatar,
  AIChatMessageContent,
  AIChatMessageFeedbackButtons,
  AIChatMessagePreamble,
  AIChatMessageSourceLinks,
  AIChatMessageTimestamp,
  AIChatSummaryDivider,
} from "./message";
import { ThinkingIndicator as AIChatThinkingIndicator } from "./thinking-indicator";

const AIChat = {
  Provider: AIChatProvider,

  Messages: AIChatMessages,
  Suggestions: AIChatSuggestionsV2,
  SuggestedPrompts: AIChatSuggestedPrompts,

  Input: Object.assign(AIChatInput, {
    TextArea: AIChatInputTextArea,
    FileUpload: AIChatInputFileUpload,
    FilePills: AIChatInputFilePills,
    SendButton: AIChatInputSendButton,
    CancelButton: AIChatInputCancelButton,
    DropZone: AIChatInputDropZone,
  }),

  Message: Object.assign(AIChatMessage, {
    Content: AIChatMessageContent,
    Preamble: AIChatMessagePreamble,
    Timestamp: AIChatMessageTimestamp,
    Avatar: AIChatMessageAvatar,
    FeedbackButtons: AIChatMessageFeedbackButtons,
    Analytics: AIChatMessageAnalytics,
    SourceLinks: AIChatMessageSourceLinks,
  }),

  SummaryDivider: AIChatSummaryDivider,
  FeedbackDialog: AIChatFeedbackDialog,
  SummaryDialog: AIChatSummaryDialog,
  ThinkingIndicator: AIChatThinkingIndicator,
  StreamingIndicator: AIChatStreamingIndicator,
  Footer: AIChatFooter,
  AgentActivityLog,
};

export { AgentActivityKind } from "./agent-activity-log";
export type {
  AgentActivityLogDetail,
  AgentActivityLogItem,
  AgentActivityStatus,
} from "./agent-activity-log";
export { AgentActivityLog, AIChat };

export { useAIChatContext } from "./contexts/ai-chat-context";
export type {
  AIChatActions,
  AIChatContextValue,
  AIChatFeedbackActions,
  AIChatFeedbackState,
  AIChatState,
} from "./contexts/ai-chat-context";
export { useAIChatInputContext } from "./contexts/ai-chat-input-context";
export { useAIChatMessageContext } from "./contexts/ai-chat-message-context";

// Re-export commonly used types from ./types
export type { AIChatSuggestedPrompt } from "./ai-chat-suggested-prompts";
export type { ChatMessage, FeedbackType, FileAttachment } from "./types";
